/**
 * gbi-sticky-scroll — scroll-progress engine.
 *
 * Usage:
 *   GBI.stickyScroll.observe('#section', (progress) => { ... });
 * Progress is 0 when the section's top hits the viewport top,
 * 1 when (section.bottom - viewport.height) passes the viewport top.
 * Honors prefers-reduced-motion (callback fires once with progress=1).
 */
(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const subscribers = new Map();

  function compute(el) {
    const rect = el.getBoundingClientRect();
    const total = rect.height - window.innerHeight;
    if (total <= 0) return rect.top <= 0 ? 1 : 0;
    const scrolled = -rect.top;
    return Math.max(0, Math.min(1, scrolled / total));
  }

  let rafScheduled = false;
  function tick() {
    rafScheduled = false;
    subscribers.forEach((cb, el) => {
      const progress = compute(el);
      cb(progress, el);
    });
  }

  function schedule() {
    if (rafScheduled) return;
    rafScheduled = true;
    requestAnimationFrame(tick);
  }

  function onScroll() { schedule(); }
  function onResize() { schedule(); }

  function observe(selectorOrEl, callback) {
    const el = typeof selectorOrEl === 'string'
      ? document.querySelector(selectorOrEl)
      : selectorOrEl;
    if (!el || typeof callback !== 'function') return () => {};

    if (reduceMotion) {
      callback(1, el);
      return () => {};
    }

    subscribers.set(el, callback);
    if (subscribers.size === 1) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });
    }
    schedule();

    return function unobserve() {
      subscribers.delete(el);
      if (subscribers.size === 0) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onResize);
      }
    };
  }

  window.GBI = window.GBI || {};
  window.GBI.stickyScroll = { observe };
})();
